$.get("https://ipinfo.io", function(data) {
    if(data.country == 'BE') {
        document.querySelectorAll('.switch-language').forEach(ele => {
            if(ele.querySelector('[data-language="belgium"]')) {
                ele.querySelector('[data-language="default"]').classList.add('hidden');
                ele.querySelector('[data-language="belgium"]').classList.remove('hidden');
            }
        });
    }

    document.querySelectorAll('.product--section').forEach(ele => {
        ele.classList.add(`country--${data.country}`);
    });
})